import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { from } from '@guardian/source/foundations';
import { gu_h_spacing, gu_span } from 'stylesheets/emotion/layout';
const baseSection = css `
	display: flex;

	${from.tablet} {
		&:before {
			content: '';
			flex-basis: 0;
			flex-grow: 1;
			display: block;
		}
	}
`;
const baseContent = css `
	flex-grow: 1;
	flex-basis: ${gu_span(9) + gu_h_spacing}px;

	${from.desktop} {
		flex-basis: ${gu_span(10) + gu_h_spacing}px;
	}

	${from.leftCol} {
		flex-basis: ${gu_span(12) + gu_h_spacing}px;
	}
`;
const fullWidthbaseContent = css `
	margin: 0 auto;
	max-width: 1290px;
`;
export default function LeftMarginSection({ children, appearance, cssOverrides, }) {
    const { fullWidth } = appearance ?? {};
    return (_jsx("section", { css: !fullWidth && baseSection, children: _jsx("div", { css: [fullWidth ? fullWidthbaseContent : baseContent, cssOverrides], children: children }) }));
}
